const SIGNIN_FROM = 'SIGNIN_FROM';

export default SIGNIN_FROM;
